"use client";

import { useTranslations } from "next-intl";
import React from "react";
import { useCountry } from "../../../ApplicationState/hooks";
import { Slider } from "../../../Slider";
import config from "./config";
import { Item } from "./item";
import styles from "./styles.module.scss";

export const TopLocations: React.FC = () => {
    const country = useCountry();
    const t = useTranslations("component.topLocations");
    const locations = config[country];

    if (locations.length === 0) {
        return null;
    }

    return (
        <div className={styles.wrapper}>
            <div className={styles.headline}>{t("title")}</div>
            <Slider
                className={styles.slider}
                minHeight="40px"
                context="topLocations"
            >
                {locations.map((location) => (
                    <Item location={location} key={location.code} />
                ))}
            </Slider>
        </div>
    );
};
